export default {"src":"/_next/static/media/plus.d08e83cc.svg","height":32,"width":32};